module.exports = __webpack_public_path__ + "img/album18_33.638fa97e.jpg";